import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import Layout_responsive from './layout/MainPage/Layout_responsive';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-jquery-plugin';
import PulseLoader from 'react-spinners/PulseLoader';
import Message from './utils/Message/Message';
import axios from 'axios';
import GeneralContext from './context/GeneralContext';
import useToken from './useToken';
import { onLogin } from './redux/auth.slice';
import Login from './layout/LoginPage/Login/Login';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { onConnection } from './redux/connection.slice';
require('dotenv').config();
export const loadingShow = (val: any, message = '') => {
  let loading = $('.splash-screen');
  $('#message-loading').html(message);
  if (val) {
    loading.css('visibility', 'visible');
  } else {
    loading.css('visibility', 'hidden');
  }
};

export let serviceUrl = 'https://data.uwork.com.au';
export var all_information: any = {};
const App1 = () => {
  const { userToken } = useSelector((state: any) => state.auth);
  const { token } = useToken();
  const dispatch = useDispatch();
  // const eventSource=new EventSource(process.env.REACT_APP_API_GLOBAL_URL + 'dig/sse/update-task');
  // eventSource.addEventListener('updateTask', (event) => {
  //   console.log(event.data);
  // })
  useEffect(() => {
    const fetchData = async () => {
      if (token) {
        loadingShow(true, 'Preparing...');
        await fetchTheCurrentUser(token);
      }
    };

    fetchData();
  }, []);
  const fetchTheCurrentUser = async (token: string) => {
    const headers = { Authorization: `Bearer ${token}` }; // auth header with bearer token
    await axios
      .get(process.env.REACT_APP_API_GLOBAL_URL + 'auth/profile', { headers })
      .then((res) => {
        if (!res.data.error) {
          if (res.data.status_code) {
            if (res.data.status_code === 401) {
              Message.error('Unauthorized login');
              return;
            }
          }
          loadingShow(false);
          if (res.data !== '' && res.data) {
            callBackData(res.data, token);
          } else {
            Message.error('Unauthorized login');
          }
        } else {
          Message.error('Something went wrong');
        }
      })
      .catch((err) => {
        if (err.isAxiosError) {
          if (err?.response?.data?.status_code === 401) {
            Message.warning('Unauthorized login. Try again');
          }
        } else {
          Message.error('Something went wrong');
        }
        loadingShow(false);
      });
  };
  useEffect(() => {
    if (userToken) {
      // all_information = restOfData;
    }
  }, [userToken]);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const callBackData = (data: any, tokken: string) => {
    let theComponents: Array<any> = data.theComponents;
    let theRole = data.isAdminRole;
    if (data.lock_account) {
      Message.error(
        'This account has been blocked. Please reach out your admin. '
      );
      return;
    }
    if(!data.status_id){
      Message.error('Non-active user. Please reach out your admin.');
      return;
    }
    if (theComponents.length === 0 && !theRole) {
      Message.error('Non Authorize user. Please reach out your admin');
      return;
    }
    all_information = data;
    all_information.token = tokken;
    dispatch(onLogin({ tokken: tokken, restOfData: data }));
  };
  useEffect(() => {
    dispatch(onConnection(navigator.onLine));

    // Update network status
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    // Listen to the online status
    window.addEventListener('online', handleStatusChange);

    // Listen to the offline status
    window.addEventListener('offline', handleStatusChange);

    // Specify how to clean up after this effect for performance improvment
    return () => {
      window.removeEventListener('online', handleStatusChange);
      window.removeEventListener('offline', handleStatusChange);
    };
  }, [isOnline]);
  return (
    <GeneralContext>
      <div>
        <div className='splash-screen'>
          <div className='loading-text'>
            <PulseLoader color='#9013FE' size={13} margin={2} />
          </div>
          <div id='message-loading'></div>
        </div>
        <div className='App'>
          {userToken && (
            <Layout_responsive
              fetchTheCurrentUser={fetchTheCurrentUser.bind(this)}
            />
          )}
          {!userToken && (
            <Login fetchTheCurrentUser={fetchTheCurrentUser.bind(this)} />
          )}
          <ToastContainer autoClose={1800} />
          <DialogComponent
            isModal={true}
            id='defaultdialogNoConnwction'
            animationSettings={{ delay: 3, effect: 'Zoom' }}
            visible={false}
            width={'300'}
          ></DialogComponent>
        </div>
      </div>
    </GeneralContext>
  );
};

export default App1;
